import { CoachingCaseBrowseRequest } from '@euler/model/coaching';
import { useServiceFactory } from '@euler/services/factory';
import { useCreation } from '@euler/utils/hooks/useCreation';
import { useLocalObservable } from '@euler/utils/hooks/useLocalObservable';
import { useCallback, useMemo } from 'react';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { CaseSearchState, caseSearchStates } from './caseSearchStates';

/** The catalog's search, a page of `pageSize` at a time. */
export function useCaseSearch(
  request$: BehaviorSubject<CoachingCaseBrowseRequest>,
  /** Each emission searches the current request again. */
  retry$: Observable<unknown>,
  pageSize: number,
): { state: CaseSearchState; loadMore: () => void } {
  const { coachingService } = useServiceFactory();
  const loadMore$ = useCreation(() => new Subject<void>(), []);
  const state = useLocalObservable<CaseSearchState>(
    () =>
      caseSearchStates(request$, retry$, loadMore$, pageSize, request =>
        coachingService.searchCases(request),
      ),
    { kind: 'loading' },
    [request$, retry$, coachingService, loadMore$, pageSize],
  );
  const loadMore = useCallback(() => loadMore$.next(), [loadMore$]);
  return useMemo(() => ({ state, loadMore }), [state, loadMore]);
}
